// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PriceRateTableCell from "../Price/PriceRateTableCell.res.js";
import * as CatalogVariant__Queries from "../../app/Catalog/CatalogVariant__Queries.res.js";
import * as CatalogVariantRetailPriceReducer from "./CatalogVariantRetailPriceReducer.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";
import * as CatalogVariantPriceRetailTableEditCellWrapper from "./CatalogVariantPriceRetailTableEditCellWrapper.res.js";
let Raw = {};
let query = Client.gql(["mutation updateVariant_retailPrices($id: ID!, $input: InputUpdateVariant!, $variantPricesInput: [InputUpdateVariantPrices!])  {\nupdateVariant(id: $id, input: $input, variantPricesInput: $variantPricesInput)  {\n__typename  \nid  \npurchasedPrice  \nvariantPrices  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \narchivedAt  \nprice  {\n__typename  \nid  \nname  \nenableByDefault  \ntaxIncluded  \n}\n\nvalueIncludingTax  \nvalueExcludingTax  \nfromQuantity  \ntoQuantity  \n}\n\n}\n\n}\n\n}\n\n}\n"]);
function parse(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.purchasedPrice;
  let value$3 = value$1.variantPrices;
  let value$4 = value$3.edges;
  return {
    updateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      purchasedPrice: !(value$2 == null) ? value$2 : undefined,
      variantPrices: {
        __typename: value$3.__typename,
        edges: value$4.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.archivedAt;
          let value$3 = value$1.price;
          let value$4 = value$1.fromQuantity;
          let value$5 = value$1.toQuantity;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              id: value$1.id,
              archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
              price: !(value$3 == null) ? {
                __typename: value$3.__typename,
                id: value$3.id,
                name: value$3.name,
                enableByDefault: value$3.enableByDefault,
                taxIncluded: value$3.taxIncluded
              } : undefined,
              valueIncludingTax: value$1.valueIncludingTax,
              valueExcludingTax: value$1.valueExcludingTax,
              fromQuantity: !(value$4 == null) ? value$4 : undefined,
              toQuantity: !(value$5 == null) ? value$5 : undefined
            }
          };
        })
      }
    }
  };
}
function serialize(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.variantPrices;
  let value$3 = value$2.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.toQuantity;
    let toQuantity = value$2 !== undefined ? value$2 : null;
    let value$3 = value$1.fromQuantity;
    let fromQuantity = value$3 !== undefined ? value$3 : null;
    let value$4 = value$1.valueExcludingTax;
    let value$5 = value$1.valueIncludingTax;
    let value$6 = value$1.price;
    let price;
    if (value$6 !== undefined) {
      let value$7 = value$6.taxIncluded;
      let value$8 = value$6.enableByDefault;
      let value$9 = value$6.name;
      let value$10 = value$6.id;
      let value$11 = value$6.__typename;
      price = {
        __typename: value$11,
        id: value$10,
        name: value$9,
        enableByDefault: value$8,
        taxIncluded: value$7
      };
    } else {
      price = null;
    }
    let value$12 = value$1.archivedAt;
    let archivedAt = value$12 !== undefined ? Scalar.Datetime.serialize(value$12) : null;
    let value$13 = value$1.id;
    let value$14 = value$1.__typename;
    let node = {
      __typename: value$14,
      id: value$13,
      archivedAt: archivedAt,
      price: price,
      valueIncludingTax: value$5,
      valueExcludingTax: value$4,
      fromQuantity: fromQuantity,
      toQuantity: toQuantity
    };
    let value$15 = value.__typename;
    return {
      __typename: value$15,
      node: node
    };
  });
  let value$4 = value$2.__typename;
  let variantPrices = {
    __typename: value$4,
    edges: edges
  };
  let value$5 = value$1.purchasedPrice;
  let purchasedPrice = value$5 !== undefined ? value$5 : null;
  let value$6 = value$1.id;
  let value$7 = value$1.__typename;
  let updateVariant = {
    __typename: value$7,
    id: value$6,
    purchasedPrice: purchasedPrice,
    variantPrices: variantPrices
  };
  return {
    updateVariant: updateVariant
  };
}
function serializeInputObjectInputUpdateVariantMetaData(inp) {
  let a = inp.shopifyVariantId;
  return {
    shopifyVariantId: a !== undefined ? a : undefined
  };
}
function serializeInputObjectInputUpdateVariant(inp) {
  let a = inp.stockKeepingUnit;
  let a$1 = inp.name;
  let a$2 = inp.purchasedPrice;
  let a$3 = inp.year;
  let a$4 = inp.capacityValue;
  let a$5 = inp.capacityUnit;
  let a$6 = inp.capacityPrecision;
  let a$7 = inp.alcoholVolume;
  let a$8 = inp.ean13;
  let a$9 = inp.internalNote;
  let a$10 = inp.metadata;
  let a$11 = inp.tastingNote;
  let a$12 = inp.packaging;
  let a$13 = inp.internalCode;
  let a$14 = inp.priceLookUpCode;
  let a$15 = inp.supplierId;
  let a$16 = inp.minStockThreshold;
  let a$17 = inp.maxStockThreshold;
  let a$18 = inp.stockOrderTriggerThreshold;
  return {
    stockKeepingUnit: a !== undefined ? a : undefined,
    name: a$1 !== undefined ? a$1 : undefined,
    purchasedPrice: a$2 !== undefined ? a$2 : undefined,
    year: a$3 !== undefined ? a$3 : undefined,
    capacityValue: a$4 !== undefined ? a$4 : undefined,
    capacityUnit: a$5 !== undefined ? a$5 : undefined,
    capacityPrecision: a$6 !== undefined ? a$6 : undefined,
    alcoholVolume: a$7 !== undefined ? a$7 : undefined,
    ean13: a$8 !== undefined ? a$8 : undefined,
    internalNote: a$9 !== undefined ? a$9 : undefined,
    metadata: a$10 !== undefined ? serializeInputObjectInputUpdateVariantMetaData(a$10) : undefined,
    tastingNote: a$11 !== undefined ? a$11 : undefined,
    packaging: a$12 !== undefined ? a$12 : undefined,
    internalCode: a$13 !== undefined ? a$13 : undefined,
    priceLookUpCode: a$14 !== undefined ? a$14 : undefined,
    supplierId: a$15 !== undefined ? a$15 : undefined,
    minStockThreshold: a$16 !== undefined ? a$16 : undefined,
    maxStockThreshold: a$17 !== undefined ? a$17 : undefined,
    stockOrderTriggerThreshold: a$18 !== undefined ? a$18 : undefined
  };
}
function serializeInputObjectInputUpdateVariantPrices(inp) {
  let a = inp.id;
  let a$1 = inp.fromQuantity;
  let a$2 = inp.toQuantity;
  return {
    id: a !== undefined ? a : undefined,
    valueIncludingTax: inp.valueIncludingTax,
    valueExcludingTax: inp.valueExcludingTax,
    fromQuantity: a$1 !== undefined ? a$1 : undefined,
    toQuantity: a$2 !== undefined ? a$2 : undefined,
    priceId: inp.priceId
  };
}
function serializeVariables(inp) {
  let a = inp.variantPricesInput;
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateVariant(inp.input),
    variantPricesInput: a !== undefined ? a.map(serializeInputObjectInputUpdateVariantPrices) : undefined
  };
}
function makeVariables(id, input, variantPricesInput, param) {
  return {
    id: id,
    input: input,
    variantPricesInput: variantPricesInput
  };
}
function makeInputObjectInputUpdateVariant(stockKeepingUnit, name, purchasedPrice, year, capacityValue, capacityUnit, capacityPrecision, alcoholVolume, ean13, internalNote, metadata, tastingNote, packaging, internalCode, priceLookUpCode, supplierId, minStockThreshold, maxStockThreshold, stockOrderTriggerThreshold, param) {
  return {
    stockKeepingUnit: stockKeepingUnit,
    name: name,
    purchasedPrice: purchasedPrice,
    year: year,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    internalNote: internalNote,
    metadata: metadata,
    tastingNote: tastingNote,
    packaging: packaging,
    internalCode: internalCode,
    priceLookUpCode: priceLookUpCode,
    supplierId: supplierId,
    minStockThreshold: minStockThreshold,
    maxStockThreshold: maxStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
}
function makeInputObjectInputUpdateVariantMetaData(shopifyVariantId, param) {
  return {
    shopifyVariantId: shopifyVariantId
  };
}
function makeInputObjectInputUpdateVariantPrices(id, valueIncludingTax, valueExcludingTax, fromQuantity, toQuantity, priceId, param) {
  return {
    id: id,
    valueIncludingTax: valueIncludingTax,
    valueExcludingTax: valueExcludingTax,
    fromQuantity: fromQuantity,
    toQuantity: toQuantity,
    priceId: priceId
  };
}
let Mutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  serializeInputObjectInputUpdateVariantPrices: serializeInputObjectInputUpdateVariantPrices,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData,
  makeInputObjectInputUpdateVariantPrices: makeInputObjectInputUpdateVariantPrices
};
let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});
let use = include.use;
let Mutation_useWithVariables = include.useWithVariables;
let Mutation = {
  Mutation_inner: Mutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  serializeInputObjectInputUpdateVariantPrices: serializeInputObjectInputUpdateVariantPrices,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData,
  makeInputObjectInputUpdateVariantPrices: makeInputObjectInputUpdateVariantPrices,
  use: use,
  useWithVariables: Mutation_useWithVariables
};
function keyExtractor(row) {
  return row.priceId + "-retail";
}
let Row = {
  keyExtractor: keyExtractor
};
let make = React.memo(props => {
  let formattedName = props.name + Stdlib_Option.mapOr(props.fromQuantity, "", current => {
    if (current > 1) {
      return ` +` + current.toString();
    } else {
      return "";
    }
  });
  let taxTypename = I18n.t(props.taxIncluded ? "VAT incl." : "VAT excl.");
  return JsxRuntime.jsxs(Inline.make, {
    children: [JsxRuntime.jsx(TextStyle.make, {
      children: formattedName,
      weight: "semibold"
    }), JsxRuntime.jsx(Badge.make, {
      children: taxTypename,
      size: "small",
      variation: "neutral"
    })],
    space: "small"
  });
});
let DecreasingPriceListTextLine = {
  make: make
};
function tableColumns(loading, allShopsFiltered, onRequestDispatch) {
  return [{
    key: "retailprice-list",
    name: I18n.t("Price list"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 220
      },
      width: {
        NAME: "fr",
        VAL: 1.5
      }
    },
    render: param => {
      let match = param.data;
      return JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(make, {
          name: match.name,
          fromQuantity: match.fromQuantity,
          taxIncluded: match.taxIncluded
        }), allShopsFiltered ? JsxRuntime.jsx(TextStyle.make, {
          children: match.shopName,
          variation: "normal",
          size: "xxsmall"
        }) : null],
        space: "xxsmall"
      });
    }
  }, {
    key: "retailprice-prices",
    name: I18n.t("Retail prices"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 130
      }
    },
    render: param => JsxRuntime.jsx(CatalogVariantPriceRetailTableEditCellWrapper.make, {
      disabled: loading,
      variantPrice: param.data,
      onRequestDispatch: onRequestDispatch
    })
  }, {
    key: "retailprice-marginrate",
    name: I18n.t("Margin rt"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 110
      }
    },
    render: param => {
      let match = param.data;
      return JsxRuntime.jsx(PriceRateTableCell.make, {
        rateType: "MarginRate",
        valueExcludingTax: match.valueExcludingTax,
        purchasePrice: match.purchasePrice,
        taxRate: match.taxRate
      });
    }
  }, {
    key: "retailprice-markuprate",
    name: I18n.t("Markup rt"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 110
      }
    },
    render: param => {
      let match = param.data;
      return JsxRuntime.jsx(PriceRateTableCell.make, {
        rateType: "MarkupRate",
        valueExcludingTax: match.valueExcludingTax,
        purchasePrice: match.purchasePrice,
        taxRate: match.taxRate
      });
    }
  }];
}
function makeVariantPricesMutationInput(variantPrices) {
  return variantPrices.filter(current => {
    if (current.edited) {
      return true;
    } else {
      return current.valueExcludingTax > 0;
    }
  }).map(param => makeInputObjectInputUpdateVariantPrices(param.id, param.valueIncludingTax, param.valueExcludingTax, param.fromQuantity, param.toQuantity, param.priceId, undefined));
}
function makeVariantPricesMutationsVariables(variantPrices) {
  return Stdlib_Array.reduce(variantPrices, [], (acc, retailPrice) => {
    let match = retailPrice.edited;
    let match$1 = acc.some(current => current.variantId === retailPrice.variantId);
    if (match && !match$1) {
      return acc.concat([retailPrice]);
    } else {
      return acc;
    }
  }).map(variantPrice => {
    let input = makeInputObjectInputUpdateVariant(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    let variantPricesInput = makeVariantPricesMutationInput(variantPrices.filter(current => current.variantId === variantPrice.variantId));
    return {
      id: variantPrice.variantId,
      input: input,
      variantPricesInput: variantPricesInput
    };
  });
}
let make$1 = React.memo(props => {
  let status = props.status;
  switch (status) {
    case "Pristine":
      return null;
    case "Editing":
    case "Submitting":
      break;
    case "SubmitSucceeded":
      return JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Banner.make, {
          textStatus: {
            TAG: "Success",
            _0: I18n.t("The retail prices have been successfully updated.")
          }
        }),
        spaceX: "large",
        spaceTop: "medium"
      });
    case "SubmitFailed":
      return JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Banner.make, {
          textStatus: {
            TAG: "Danger",
            _0: I18n.t("Wino could not update the retail prices, please refresh the page before trying again.")
          }
        }),
        spaceX: "large",
        spaceTop: "medium"
      });
  }
  let newrecord = {
    ...{
      style: {
        alignSelf: "flex-end"
      }
    }
  };
  return JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(Button.make, {
        label: I18n.t("Discard"),
        size: "small",
        disabled: status === "Submitting",
        onPress: props.onRequestDiscard
      }), JsxRuntime.jsx(Button.make, {
        label: I18n.t("Save prices"),
        variant: "solid",
        tone: "success",
        size: "small",
        pending: status === "Submitting",
        onPress: props.onRequestSave
      })],
      space: "small"
    }),
    spaceX: "large",
    spaceTop: "medium",
    spaceBottom: "xxsmall"
  }), newrecord));
});
let SaveActionBar = {
  make: make$1
};
function use$1(value) {
  let ref = React.useRef(undefined);
  React.useEffect(() => {
    ref.current = Primitive_option.some(value);
  }, []);
  return ref.current;
}
function useChange(fn, value) {
  let previousValue = use$1(value);
  React.useEffect(() => {
    if (previousValue !== undefined) {
      return fn();
    }
  }, [Primitive_object.notequal(Stdlib_Option.getOr(previousValue, value), value)]);
}
let PreviousHook = {
  use: use$1,
  useChange: useChange
};
function CatalogVariantRetailPriceTableCard(props) {
  let variantPrices = props.variantPrices;
  let cku = props.cku;
  let activeShop = Auth.useActiveShop();
  let captureEvent = SessionTracker.useCaptureEvent();
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutation = match[1];
  let mutate = match[0];
  let match$1 = React.useState(() => "Pristine");
  let setStatus = match$1[1];
  let status = match$1[0];
  let match$2 = React.useReducer(CatalogVariantRetailPriceReducer.make, variantPrices);
  let dispatch = match$2[1];
  let rows = match$2[0];
  useChange(() => {
    dispatch({
      TAG: "Reset",
      _0: variantPrices
    });
  }, [variantPrices.map(param => [param.id, param.valueExcludingTax])]);
  useChange(() => {
    dispatch({
      TAG: "RetailPricesPurchaseValueUpdated",
      _0: variantPrices
    });
  }, [variantPrices.map(param => param.purchasePrice)]);
  ReactUpdateEffect.use1(() => {
    setStatus(param => "Pristine");
  }, [activeShop]);
  React.useEffect(() => {
    if (rows.some(row => row.edited)) {
      setStatus(param => "Editing");
    }
  }, [rows]);
  React.useEffect(() => {
    if (mutation.loading) {
      setStatus(param => "Submitting");
    }
  }, [mutation.loading]);
  let onRequestDiscard = React.useCallback(() => {
    dispatch({
      TAG: "Reset",
      _0: variantPrices
    });
    setStatus(param => "Pristine");
  }, [variantPrices]);
  let onRequestSave = React.useCallback(() => {
    Future.get(ApolloHelpers.mergeFutureResults(makeVariantPricesMutationsVariables(rows).map(mutationVariables => ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, [CatalogVariant__Queries.VariantQuery.refetchQueryDescription(undefined, undefined, CatalogVariant__Queries.VariantQuery.makeVariables(Scalar.CKU.serialize(cku), undefined, undefined))], undefined, mutationVariables)))), result => setStatus(param => {
      if (result.TAG === "Ok") {
        return "SubmitSucceeded";
      } else {
        return "SubmitFailed";
      }
    }));
    captureEvent("catalog_variant_page_retailprice_click_save");
  }, [rows]);
  let match$3 = Auth.useScope();
  let allShopsFiltered;
  allShopsFiltered = match$3.TAG === "Organisation" ? match$3.activeShop === undefined : false;
  let columns = React.useMemo(() => tableColumns(status === "Submitting", allShopsFiltered, dispatch), [status, allShopsFiltered]);
  let placeholderEmptyState = JsxRuntime.jsx(Placeholder.make, {
    status: "NoDataAvailable",
    customText: I18n.t("No price list has been yet recorded")
  });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(Navigation.Prompt.make, {
      message: I18n.t("Some changes in the retail prices have not been saved."),
      shouldBlockOnRouteChange: param => {
        if (status === "Editing") {
          return true;
        } else {
          return status === "Submitting";
        }
      }
    }), JsxRuntime.jsxs(Card.make, {
      children: [JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(NextBanner.make, {
          children: JsxRuntime.jsx(NextBanner.Text.make, {
            text: I18n.t("catalog_variant_page.retail_price_card.banner.text")
          }),
          variation: "info",
          maxLines: 1
        }),
        spaceX: "large",
        spaceY: "small"
      }), JsxRuntime.jsx(TableView.make, {
        data: {
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: rows
          }
        },
        columns: columns,
        keyExtractor: keyExtractor,
        maxHeight: 325,
        placeholderEmptyState: placeholderEmptyState
      }), JsxRuntime.jsx(make$1, {
        status: status,
        onRequestDiscard: onRequestDiscard,
        onRequestSave: onRequestSave
      })],
      title: I18n.t("Retail prices"),
      variation: "table",
      shadowed: status === "Editing"
    })]
  });
}
let make$2 = React.memo(CatalogVariantRetailPriceTableCard, (oldProps, newProps) => {
  if (oldProps.variantPrices === newProps.variantPrices) {
    return oldProps.cku === newProps.cku;
  } else {
    return false;
  }
});
let RetailPriceReducer;
let VariantQuery;
export { RetailPriceReducer, VariantQuery, Mutation, Row, DecreasingPriceListTextLine, tableColumns, makeVariantPricesMutationInput, makeVariantPricesMutationsVariables, SaveActionBar, PreviousHook, make$2 as make };
/* query Not a pure module */